import { useContext } from 'react';
import { createContext } from 'react';

import { NewsletterSubmitProps } from '../@types/NewsletterSubmitProps';

export const NewsletterSubmitContext = createContext<NewsletterSubmitProps>({} as NewsletterSubmitProps);

NewsletterSubmitContext.displayName = 'NewsletterSubmit';

const NewsletterSubmitProvider = (props: NewsletterSubmitProps) => (
	<NewsletterSubmitContext.Provider value={props}>{props.children}</NewsletterSubmitContext.Provider>
);

export const useNewsletterSubmit = () => {
	const context = useContext(NewsletterSubmitContext);

	return context;
};

export default NewsletterSubmitProvider;
